import i18n from '@/lang/index.js'
import { useAuthStore } from '@/stores/authStore.js'

async function authMiddleware (to, from, next) {
  const authStore = useAuthStore()

  if (to.meta.requiresAuth) {
    if (authStore.isAuthenticated) {
      next()
    } else {
      next({
        replace: true,
        name   : 'Home',
        params : { locale: i18n.locale },
        query  : to?.query || {}
      })
    }
  } else {
    next()
  }
}

export default authMiddleware
